<template>
  <div
    class="py-3 px-4 d-flex align-items-center justify-content-between eg-modal__header flex-gap-1"
  >
    <slot name="title" :title="title">
      <h3 class="semi-bold eg-modal__title flex-grow-1 heading-s">
        {{ title }}
      </h3>
    </slot>
    <slot />
    <eg-button
      v-if="closable"
      data-testid="modal-close"
      type="ordinary"
      size="medium"
      class="eg-modal__close"
      icon="close"
      icon-size="medium"
      icon-color="var(--color-icon-neutral-neutral)"
      @click="$emit('onClose')"
    />
  </div>
</template>

<script>
export default {
  name: "EgModalHeader",
  props: {
    title: { type: String, required: true },
    closable: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.eg-modal__header {
  border-bottom: 1px solid var(--color-stroke-neutral-default);
}

.eg-modal__title {
  margin: 0;
}
</style>
